import Snaker from '../index'
import { getElementXPath } from './utils'

export default function createWebClick (snaker: Snaker, genExtraData?: Function) {
  function handleClick (ev: MouseEvent) {
    const el = ev.target as Element
    const xpath = getElementXPath(el)
    let extraData = {}
    if (genExtraData !== undefined) {
      Object.assign(extraData, genExtraData(ev))
    }
    snaker.trackAsync('webClick', location.pathname, xpath, extraData)
  }
  function start () {
    document.addEventListener('click', handleClick)
  }

  return {
    start
  }
}
